import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { PlaceholderComponent } from './pages/placeholder/placeholder.component';

export const routes: Routes = [
  { 
    path: '', 
    component: HomeComponent 
  },
  { 
    path: 'services',
    loadChildren: () => import('./pages/services/services.module').then(m => m.ServicesModule)
  },
  { 
    path: 'clients', 
    component: PlaceholderComponent,
    data: { pageTitle: 'Our Clients' }
  },
  { 
    path: 'about', 
    component: PlaceholderComponent,
    data: { pageTitle: 'About Us' }
  },
  { 
    path: 'testimonials', 
    component: PlaceholderComponent,
    data: { pageTitle: 'Testimonials' }
  },
  { 
    path: 'case-studies', 
    component: PlaceholderComponent,
    data: { pageTitle: 'Case Studies' }
  },
  { 
    path: '**', 
    redirectTo: '' 
  }
];
